import React, { useState } from "react";
import { useLang, LANGUAGES } from "../lib/i18n";
import { Globe, ChevronDown } from "lucide-react";

export const LanguageSwitcher = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <div className={`relative ${className}`} data-testid="language-switcher">
      <button
        data-testid="language-toggle"
        onClick={() => setOpen((v) => !v)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        className="flex items-center gap-2 px-3 py-1.5 border border-[color:var(--goldenelia-gold)]/40 text-[color:var(--goldenelia-gold)] hover:border-[color:var(--goldenelia-gold)] hover:bg-[color:var(--goldenelia-gold)]/10 transition-colors font-display text-[10px] tracking-[0.3em] uppercase"
      >
        <Globe size={12} />
        {current.label}
        <ChevronDown size={11} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <ul
          data-testid="language-menu"
          className="absolute right-0 mt-2 min-w-[140px] bg-black border border-[color:var(--goldenelia-gold)]/40 shadow-xl z-50"
        >
          {LANGUAGES.map((l) => (
            <li key={l.code}>
              <button
                data-testid={`language-${l.code}`}
                onMouseDown={(e) => {
                  e.preventDefault();
                  setLang(l.code);
                  setOpen(false);
                }}
                className={`w-full text-left px-4 py-2 font-display text-[11px] tracking-[0.25em] uppercase transition-colors ${
                  l.code === lang
                    ? "bg-[color:var(--goldenelia-gold)]/15 text-[color:var(--goldenelia-gold-bright)]"
                    : "text-[color:var(--goldenelia-cream)]/80 hover:bg-[color:var(--goldenelia-gold)]/10 hover:text-[color:var(--goldenelia-gold)]"
                }`}
              >
                {l.label} · {l.name}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;
